import axios from 'axios'
import store from '@/store'
import { ToastProgrammatic as Toast } from 'buefy'

export default () => {
  /* eslint no-console: ["error", { allow: ["warn", "error", "log", "info"] }] */

  let api = axios.create({
    // baseURL: 'http://127.0.0.1:8000/api',
    // baseURL: 'http://192.168.15.166:8000/api',
    baseURL: 'https://api.virtualred.com.br/api',
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    validateStatus: (status) => status < 500
  })

  api.interceptors.response.use(function (response) {
    let message = ''
    let isError = false

    console.log(response);
    if (response.status > 424) {
      console.log("entrou");
      message = response.data
      isError = true
    }

    if (response.status === 424) {
      message = 'Você não possui mais créditos'
      isError = true
    }

    if (response.status === 422) {
      message = 'Erro ao enviar formulário, campos inválidos'
      isError = true
    }

    if (response.status === 405) {
      message = 'Não encontramos o que procura'
      isError = true
    }

    if (response.status === 404) {
      message = 'Não encontramos o que procura'
      isError = true
    }

    if (response.status === 403) {
      message = 'Operação não permitida'
      isError = true
    }

    if (response.status === 401) {
      if (response.data.message === 'Unauthenticated.') {
        store.commit('logout')
        window.location.href = '/'
      }
      message = 'Permissão negada'
      isError = true
    }

    if (response.status === 400) {
      if (response.data.message) {
        message = response.data.message
      } else {
        message = 'Requisição inválida'
      }

      isError = true
    }

    if (isError) {
      return Promise.reject(new Error(message))
    }

    return response
  }, error => {
    let message = ''
    if (!error.status) {
      message = 'Erro ao conectar no servidor'
    }
    Toast.open({
      duration: 5000,
      message: message,
      position: 'is-top-right',
      type: 'is-danger'
    })

    return Promise.reject(new Error())
  })

  api.downloadFile = (url, filename) => {
    api({
      url: url,
      method: 'GET',
      responseType: 'blob' // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    })
  }

  return api
}
